<div class="flex-fill d-flex flex-column">
    <div class="btn-toolbar">
        @if (hasChanges()) {
            <button (click)="save()" class="btn btn-sm btn-primary me-2">Save</button>
        }
        @if (hasChanges()) {
            <button (click)="cancel()" class="btn btn-sm btn-success me-4">Cancel</button>
        }
        @if (!hasChanges()) {
            <button (click)="close()" class="btn btn-sm btn-primary me-4">Close</button>
        }
    </div>
    @if (customer) {
        <div class="flex-fill p-3">
            <dx-form [formData]="customer" [validationGroup]="'customerValidationGroup'" [readOnly]="!canEdit">
                <dxi-item itemType="group" caption="Customer Information" [colCount]="2">
                    <dxi-item itemType="group" [colCount]="1">
                        <dxi-item
                            dataField="typeId"
                            [label]="{ text: 'Customer Type' }"
                            [editorType]="'dxSelectBox'"
                            [editorOptions]="{ dataSource: customerTypes, displayExpr: 'name', valueExpr: 'id' }"
                        >
                            <dxi-validation-rule type="range" [min]="1" message="Required"> </dxi-validation-rule>
                            <dxi-validation-rule type="required" message="Required"> </dxi-validation-rule>
                        </dxi-item>
                        <dxi-item itemType="empty"></dxi-item>
                        <dxi-item dataField="companyName"></dxi-item>
                        <dxi-item itemType="group" [colCount]="2">
                            <dxi-item dataField="customerUnixKey" [label]="{ text: 'Customer Key' }">
                                <dxi-validation-rule type="custom" [validationCallback]="isUnique" message="Customer Key must be unique"> </dxi-validation-rule>
                            </dxi-item>
                            <dxi-item itemType="empty"></dxi-item>
                            <dxi-item dataField="firstName"></dxi-item>
                            <dxi-item itemType="empty"></dxi-item>
                            <dxi-item dataField="lastName"></dxi-item>
                            <dxi-item itemType="empty"></dxi-item>
                            <dxi-item dataField="phone"></dxi-item>
                            <dxi-item dataField="email"></dxi-item>
                            <dxi-item dataField="quickBooksId" [label]="{ text: 'QB ID' }" [editorOptions]="{ disabled: true }"></dxi-item>
                            <dxi-item dataField="quickBooksLastExport" [label]="{ text: 'QB Export' }" [editorOptions]="{ disabled: true }"></dxi-item>
                        </dxi-item>
                    </dxi-item>
                    <dxi-item itemType="group" caption="Billing Information" [colCount]="1">
                        <dxi-item dataField="billAddress1" [label]="{ text: 'Address 1' }"></dxi-item>
                        <dxi-item dataField="billAddress2" [label]="{ text: 'Address 2' }"></dxi-item>
                        <dxi-item dataField="billCity" [label]="{ text: 'City' }"></dxi-item>
                        <dxi-item itemType="group" [colCount]="3">
                            <dxi-item dataField="billState" [label]="{ text: 'State' }" [visible]="customer.billCountry === 'OTHER'"></dxi-item>
                            <dxi-item
                                dataField="billState"
                                [label]="{ text: 'State' }"
                                editorType="dxSelectBox"
                                [editorOptions]="{ items: states, showClearButton: false }"
                                [visible]="customer.billCountry !== 'OTHER'"
                            ></dxi-item>
                            <dxi-item dataField="billZip" [label]="{ text: 'Zip' }"></dxi-item>
                            <dxi-item
                                dataField="billCountry"
                                [label]="{ text: 'Country' }"
                                editorType="dxSelectBox"
                                [editorOptions]="{ items: countries, showClearButton: false }"
                            ></dxi-item>
                        </dxi-item>
                        <dxi-item itemType="group" [colCount]="3">
                            <dxi-item
                                dataField="preferredCommunication"
                                [label]="{ text: 'Communication' }"
                                editorType="dxSelectBox"
                                [editorOptions]="{ items: communicationOptions, showClearButton: false }"
                            ></dxi-item>
                            <dxi-item
                                dataField="terms"
                                [label]="{ text: 'Terms' }"
                                editorType="dxSelectBox"
                                [editorOptions]="{ items: terms, valueExpr: 'name', displayExpr: 'name', showClearButton: false }"
                            ></dxi-item>
                            <dxi-item dataField="taxCodeString"></dxi-item>
                            <dxi-item
                                dataField="taxCodeId"
                                [label]="{ text: 'Tax Code' }"
                                editorType="dxSelectBox"
                                [editorOptions]="{ items: taxCodes, valueExpr: 'id', displayExpr: 'name', showClearButton: false }"
                            ></dxi-item>
                            <dxi-item
                                dataField="paymentMethodId"
                                [label]="{ text: 'Payment Method' }"
                                editorType="dxSelectBox"
                                [editorOptions]="{ items: paymentMethods, valueExpr: 'id', displayExpr: 'name', showClearButton: false }"
                            ></dxi-item>
                            <dxi-item editorType="empty" [colSpan]="2"></dxi-item>
                            <dxi-item dataField="requirePoOnInvoices"></dxi-item>
                            <dxi-item editorType="empty">
                                <div *dxTemplate>
                                    <div class="d-flex align-items-center" style="gap: 6px">
                                        <dx-check-box [value]="hasActiveOverrides" [readOnly]="true"></dx-check-box>
                                        <label class="mb-0">Has Active Price Overrides</label>
                                    </div>
                                </div>
                            </dxi-item>
                        </dxi-item>
                    </dxi-item>
                    <dxi-item itemType="group" caption="Notes" [colCount]="1">
                        <dxi-item dataField="notes" [label]="{ text: 'Notes' }" editorType="dxTextArea" [editorOptions]="{ readOnly: true, height: '150px' }"> </dxi-item>
                    </dxi-item>
                    <dxi-item itemType="group" [colSpan]="3" [colCount]="1">
                        <dxi-item itemType="group" caption="Attachments">
                            <div *dxTemplate>
                                @if (attachments) {
                                    <ul style="list-style-type: none; padding-inline-start: 0px">
                                        @for (attachment of attachments; track attachment) {
                                            <li>
                                                <a title="remove" (click)="removeAttachment(attachment)"> <i class="fa fa-times" aria-hidden="true"></i> </a>
                                                <a title="view" class="ms-1" (click)="openAttachment(attachment)">{{ attachment.name }}</a>
                                            </li>
                                        }
                                    </ul>
                                }
                            </div>
                        </dxi-item>
                        <dxi-item>
                            <div *dxTemplate>
                                <dx-file-uploader
                                    name="fileUpload"
                                    selectButtonText="Select File(s)"
                                    class="attachments"
                                    accept="*"
                                    uploadMode="instantly"
                                    [readOnly]="!canEdit"
                                    [showFileList]="false"
                                    [multiple]="true"
                                    [uploadUrl]="uploadUrl"
                                    [uploadHeaders]="uploadHeader"
                                    [disabled]="key === 'new'"
                                    (onUploadStarted)="uploadStarted($event)"
                                    (onUploadError)="uploadError($event)"
                                    (onUploaded)="uploaded($event)"
                                >
                                </dx-file-uploader>
                            </div>
                        </dxi-item>
                    </dxi-item>
                </dxi-item>
            </dx-form>
            @if (canEdit) {
                <dx-tab-panel class="flex-fill d-flex flex-column mt-3" [disabled]="key === 'new'">
                    <!-- <dxi-item [title]="'Projects'" class="flex-fill d-flex flex-column p-3">
          <dx-data-grid #dataGrid [dataSource]="projects" keyExpr="id" class="grid-fill" height="500px">
            <dxi-column dataField="projectNumber" caption="Project #" width="125"></dxi-column>
            <dxi-column dataField="name" width="225"></dxi-column>
            <dxi-column dataField="description" [format]="{ type: 'currency', precision: 5 }" width="175"></dxi-column>
            <dxi-column></dxi-column>
            <dxo-column-chooser [enabled]="false"></dxo-column-chooser>
            <dxo-summary>
              <dxi-total-item column="cost" summaryType="sum" [valueFormat]="{ type: 'currency', precision: 5 }"> </dxi-total-item>
            </dxo-summary>
            <div *dxTemplate="let data of 'toolbarButtons'">
              <button class="btn btn-sm btn-success" (click)="addProject()">Add</button>
              <button
                class="btn btn-sm btn-primary ms-2"
                (click)="addProject(dataGrid.instance.getSelectedRowsData()[0])"
                [disabled]="dataGrid.instance.getSelectedRowsData().length !== 1"
                >
                Edit
              </button>
              <button class="btn btn-sm btn-danger ms-2" (click)="deleteProject()" [disabled]="dataGrid.instance.getSelectedRowsData().length !== 1">Delete</button>
            </div>
            <div *dxTemplate="let data of 'toolbarText'">
              <span *ngIf="projects" class="me-3"
                ><strong
                >{{ dataGrid.instance.totalCount() + " items" }}
                {{ dataGrid.instance.getSelectedRowsData().length > 0 ? dataGrid.instance.getSelectedRowsData().length + " selected" : "" }}
              </strong></span
              >
            </div>
          </dx-data-grid>
        </dxi-item>
        <dxi-item [title]="'Invoices'" class="flex-fill d-flex flex-column p-3"> </dxi-item> -->
                    <dxi-item [title]="'Mix Strengths'" class="flex-fill d-flex flex-column p-3">
                        <dx-data-grid
                            #mixStrengthsDataGrid
                            [dataSource]="customerMixStrengths"
                            keyExpr="id"
                            class="grid-fill"
                            (onRowDblClick)="mixStrengthRowDoubleClick($event)"
                            (onRowUpdated)="onRowUpdated($event)"
                            height="500px"
                            [customizeColumns]="customizeColumns"
                        >
                            <dxi-column dataField="mixStrength.name" caption="Mix Strength" width="300"></dxi-column>
                            <dxi-column dataField="price" [format]="{ type: 'currency', precision: 2 }" width="150" [allowEditing]="true"></dxi-column>
                            <dxi-column></dxi-column>
                            <dxo-editing [mode]="'cell'" [allowUpdating]="true"></dxo-editing>
                            <dxo-selection [mode]="'multiple'"></dxo-selection>
                            <dxo-state-storing [enabled]="true" type="localStorage" storageKey="customer-mix-strength-grid"></dxo-state-storing>
                            <div *dxTemplate="let data of 'toolbarButtons'">
                                <div class="d-flex">
                                    <button class="btn btn-sm btn-secondary" (click)="generateMixStrengths()">Generate</button>
                                    <button class="btn btn-sm btn-success ms-3" (click)="editMixStrength()">Add</button>
                                    <button
                                        class="btn btn-sm btn-primary ms-2"
                                        (click)="editMixStrength(mixStrengthsDataGrid.instance.getSelectedRowsData()[0])"
                                        [disabled]="mixStrengthsDataGrid.instance.getSelectedRowsData().length !== 1"
                                    >
                                        Edit
                                    </button>
                                    <button
                                        class="btn btn-sm btn-danger ms-2"
                                        (click)="deleteMixStrength(mixStrengthsDataGrid.instance.getSelectedRowsData())"
                                        [disabled]="mixStrengthsDataGrid.instance.getSelectedRowsData().length === 0"
                                    >
                                        Delete
                                    </button>
                                    <button class="btn btn-sm btn-secondary ms-2" (click)="increaseRediMixPricing()">Increase Redi-Mix Pricing</button>
                                    <div class="d-flex align-items-baseline ms-4" style="gap: 10px">
                                        <label>Limestone Charge</label>
                                        <dx-number-box [(value)]="limestoneCharge" [format]="{ type: 'currency', precision: 2 }" width="100"></dx-number-box>
                                        <button class="btn btn-sm btn-secondary" (click)="applyLimestoneCharge()">Apply</button>
                                    </div>
                                    <button
                                        class="btn btn-sm btn-secondary ms-4"
                                        (click)="copyMixStrengths(mixStrengthsDataGrid.instance.getSelectedRowsData())"
                                        [disabled]="mixStrengthsDataGrid.instance.getSelectedRowsData().length === 0"
                                    >
                                        Copy To Other Customer
                                    </button>
                                </div>
                            </div>
                            <div *dxTemplate="let data of 'toolbarText'">
                                @if (projects) {
                                    <span class="me-3">
                                        <strong>
                                            {{ mixStrengthsDataGrid.instance.totalCount() + " items" }}
                                            {{
                                                mixStrengthsDataGrid.instance.getSelectedRowsData().length > 0
                                                    ? mixStrengthsDataGrid.instance.getSelectedRowsData().length + " selected"
                                                    : ""
                                            }}
                                        </strong>
                                    </span>
                                }
                            </div>
                        </dx-data-grid>
                    </dxi-item>
                    <dxi-item [title]="'Product Pricing Overrides'" class="flex-fill d-flex flex-column p-3">
                        <dx-data-grid
                            #productPriceOverridesDataGrid
                            [dataSource]="customerProductPriceOverrides"
                            keyExpr="id"
                            class="grid-fill"
                            (onRowDblClick)="productPriceOverrideRowDoubleClick($event)"
                            height="500px"
                        >
                            <dxi-column dataField="product.description" caption="Product" width="300"></dxi-column>
                            <dxi-column dataField="price" [format]="{ type: 'currency', precision: 2 }" width="150"></dxi-column>
                            <dxi-column dataField="endDate" caption="End Date" width="150"></dxi-column>
                            <dxi-column></dxi-column>
                            <dxo-selection [mode]="'multiple'"></dxo-selection>
                            <dxo-state-storing [enabled]="true" type="localStorage" storageKey="customer-product-price-override-grid"></dxo-state-storing>
                            <div *dxTemplate="let data of 'toolbarButtons'">
                                <div class="d-flex">
                                    <button class="btn btn-sm btn-success" (click)="editProductPriceOverride()">Add</button>
                                    <button
                                        class="btn btn-sm btn-primary ms-2"
                                        (click)="editProductPriceOverride(productPriceOverridesDataGrid.instance.getSelectedRowsData()[0])"
                                        [disabled]="productPriceOverridesDataGrid.instance.getSelectedRowsData().length !== 1"
                                    >
                                        Edit
                                    </button>
                                    <button
                                        class="btn btn-sm btn-danger ms-2"
                                        (click)="deleteProductPriceOverride(productPriceOverridesDataGrid.instance.getSelectedRowsData())"
                                        [disabled]="productPriceOverridesDataGrid.instance.getSelectedRowsData().length === 0"
                                    >
                                        Delete
                                    </button>
                                </div>
                            </div>
                            <div *dxTemplate="let data of 'toolbarText'">
                                <span class="me-3">
                                    <strong>
                                        {{ productPriceOverridesDataGrid.instance.totalCount() + " items" }}
                                        {{
                                            productPriceOverridesDataGrid.instance.getSelectedRowsData().length > 0
                                                ? productPriceOverridesDataGrid.instance.getSelectedRowsData().length + " selected"
                                                : ""
                                        }}
                                    </strong>
                                </span>
                            </div>
                        </dx-data-grid>
                    </dxi-item>
                    <dxi-item [title]="'Invoices'" class="flex-fill d-flex flex-column p-3">
                        <dx-data-grid #invoiceDataGrid [dataSource]="invoices" keyExpr="id" class="grid-fill" height="500px">
                            <dxi-column dataField="invoiceNumber" caption="Invoice #" width="80"></dxi-column>
                            <dxi-column dataField="statusName" caption="Status" width="100"></dxi-column>
                            <dxi-column dataField="invoiceDate" caption="Date" width="100"></dxi-column>
                            <dxi-column dataField="dueDate" width="100"></dxi-column>
                            <dxi-column dataField="subTotal" width="100" [format]="{ type: 'currency', precision: 2 }"></dxi-column>
                            <dxi-column dataField="tax" width="100" [format]="{ type: 'currency', precision: 2 }"></dxi-column>
                            <dxi-column dataField="total" width="100" [format]="{ type: 'currency', precision: 2 }"></dxi-column>
                            <dxi-column dataField="balance" width="100" [format]="{ type: 'currency', precision: 2 }"></dxi-column>
                            <dxi-column></dxi-column>
                            <dxo-search-panel class="d-none d-sm-block" [visible]="true"></dxo-search-panel>
                            <dxo-export [enabled]="true" [allowExportSelectedData]="true"></dxo-export>
                            <dxo-filter-row [visible]="true"></dxo-filter-row>
                            <dxo-state-storing [enabled]="true" type="localStorage" storageKey="customer-invoice-grid"></dxo-state-storing>
                            <dxo-column-chooser [enabled]="false"></dxo-column-chooser>
                            <div *dxTemplate="let data of 'toolbarButtons'">
                                <button
                                    class="btn btn-sm btn-primary ms-2"
                                    (click)="openInvoice(invoiceDataGrid.instance.getSelectedRowsData()[0])"
                                    [disabled]="invoiceDataGrid.instance.getSelectedRowsData().length !== 1"
                                >
                                    Open
                                </button>
                            </div>
                            <div *dxTemplate="let data of 'toolbarText'">
                                @if (invoices) {
                                    <span class="me-3">
                                        <strong>
                                            {{ invoiceDataGrid.instance.totalCount() + " items" }}
                                            {{
                                                invoiceDataGrid.instance.getSelectedRowsData().length > 0 ? invoiceDataGrid.instance.getSelectedRowsData().length + " selected" : ""
                                            }}
                                        </strong>
                                    </span>
                                }
                            </div>
                        </dx-data-grid>
                    </dxi-item>
                </dx-tab-panel>
            }
        </div>
    }
</div>
